module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root"
  }, [_c('div', {
    staticClass: "header-box add-bg"
  }, [_c('div', {
    staticClass: "c-header"
  }, [_vm._m(0), _c('ul', {
    staticClass: "nav"
  }, _vm._l((_vm.navList), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      class: {
        active: index == _vm.currentPage
      },
      on: {
        "click": function($event) {
          return _vm.goUrl(item.url)
        }
      }
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)])]), _c('div', {
    staticClass: "content"
  }, [_c('a', {
    attrs: {
      "href": "/#/joinUs"
    }
  }, [_vm._v("返回职位列表")]), (JSON.stringify(_vm.jobDetail) === '{}') ? _c('div') : _c('div', {
    staticClass: "job-detail"
  }, [_c('h2', [_vm._v(_vm._s(_vm.jobDetail.positionName))]), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.jobDetail.positionType) + " | " + _vm._s(_vm.jobDetail.workPlace))]), _c('li', [_vm._v(_vm._s(_vm.jobDetail.department))]), _c('li', [_vm._v(_vm._s(_vm.jobDetail.positionName))])]), _c('div', {
    staticClass: "describe",
    domProps: {
      "innerHTML": _vm._s(_vm.jobDetail.content)
    }
  }), _vm._m(1), _vm._m(2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-logo"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/header-logo-orange-xd.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("简历投递邮箱:"), _c('span', [_vm._v("jrzp@bajiegroup.com")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "more"
  }, [_c('a', {
    attrs: {
      "href": "/#/joinUsMain"
    }
  }, [_vm._v("查看更多")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5dd8fe86", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5dd8fe86","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@zbj/vue-mixin-loader?{"mixinPath":"D://zhubajie//Project//nodejs-zbjfins-web//app//resource//global//css//mixin//mixin.less"}!./app/resource/page/index/views/joinUsDetail.vue
// module id = 1197
// module chunks = 2